import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table, Form, Button, Spinner, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import Layout from "../../../layout/default";
import { Link } from "react-router-dom";
import Block from "../../../components/Block/Block";

const OrderItemsForSupplier = () => {
    const [orderItems, setOrderItems] = useState([]);
    const [vendors, setVendors] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [filters, setFilters] = useState({
        user_id: '', // Vendor ID
        order_statuses: [], // Selected order statuses
    });

    const [statusOptions, setStatusOptions] = useState([
        { value: '0', label: 'Pending' },
        { value: '1', label: 'Confirmed' },
        { value: '2', label: 'Delivered' },
    ]);

    const fetchVendors = async () => {
        try {
            const authToken = localStorage.getItem('authToken');
            const response = await axios.get(`${process.env.REACT_APP_HOST}api/vendors`, {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });
            setVendors(response.data);
        } catch (err) {
            console.error('Error fetching vendors:', err);
        }
    };

    const fetchOrderItems = async (applyFilters = false) => {
        setLoading(true);
        setError(null);

        try {
            const authToken = localStorage.getItem('authToken');
            const params = applyFilters
                ? {
                    vendorUser_id: filters.user_id || null,
                    order_statuses: filters.order_statuses.map((status) => status.value),
                }
                : {}; // No filters for initial load

            const response = await axios.get(`${process.env.REACT_APP_HOST}api/orders/get-supplier-orders`, {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
                params,
            });

            setOrderItems(response.data);
        } catch (err) {
            setError(err.response?.data?.error || 'An error occurred while fetching data.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchVendors();
        fetchOrderItems(); // Fetch all orders on initial load
    }, []);

    const handleVendorChange = (e) => {
        const { value } = e.target;
        setFilters((prevFilters) => ({
            ...prevFilters,
            user_id: value,
        }));
    };

    const handleStatusChange = (selectedOptions) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            order_statuses: selectedOptions || [],
        }));
    };

    const handleGoClick = () => {
        fetchOrderItems(true); // Apply filters
    };

    return (
        <Layout title="Order Items for Supplier">
            <Block.HeadContent>
                <ul className="d-flex">
                    <li>
                        <Link
                            to="/shop/admin/admin-panel"
                            className="btn btn-primary btn-md d-md-none"
                        >
                            <span>Go To Panel</span>
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="/shop/admin/admin-panel"
                            className="btn btn-primary d-none d-md-inline-flex"
                        >
                            <span>Go To Panel</span>
                        </Link>
                    </li>
                </ul>
            </Block.HeadContent>
            <div className="container mt-4">
                <h2>Order Items for Supplier</h2>

                <Form className="mb-3">
                    <Form.Group controlId="vendorFilter" className="mb-2">
                        <Form.Label>Vendor</Form.Label>
                        <Form.Control
                            as="select"
                            name="user_id"
                            value={filters.user_id}
                            onChange={handleVendorChange}
                        >
                            <option value="">Select a Vendor</option>
                            {vendors.map((vendor) => (
                                <option key={vendor.id} value={vendor.user_id || ''}>
                                    {`${vendor.first_name} ${vendor.last_name}`.trim() || vendor.business_name || 'Unknown'}
                                </option>
                            ))}
                        </Form.Control>
                    </Form.Group>

                    <Row className="justify-content-center mb-3">
                        <Col xs="auto">
                            <Select
                                isMulti
                                options={statusOptions}
                                value={filters.order_statuses}
                                onChange={handleStatusChange}
                                placeholder="Select Order Status"
                                className="mb-2"
                            />
                        </Col>
                    </Row>

                    <Button variant="primary" onClick={handleGoClick} disabled={loading}>
                        {loading ? <Spinner animation="border" size="sm" /> : 'Go'}
                    </Button>
                </Form>

                {error && <div className="alert alert-danger">{error}</div>}

                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>Product ID</th>
                            <th>Variant ID</th>
                            <th>Product Title</th>
                            <th>Variant Title</th>
                            <th>Unit Quantity</th>
                            <th>Unit Title</th>
                            <th>Total Quantity</th>
                            <th>Image</th>
                            <th>Category ID</th>
                        </tr>
                    </thead>
                    <tbody>
                        {orderItems.length > 0 ? (
                            orderItems.map((item) => (
                                <tr key={item.product_variant_id}>
                                    <td>{item.Product_ID}</td>
                                    <td>{item.product_variant_id}</td>
                                    <td>{item.product_title || 'N/A'}</td>
                                    <td>{item.product_variant_title || 'N/A'}</td>
                                    <td>{item.Unit_Quantity}</td>
                                    <td>{item.Unit_title}</td>
                                    <td>{item.total_quantity}</td>
                                    <td>
                                        {item.image_url ? (
                                            <img
                                                src={`${process.env.REACT_APP_HOST}/storage/${item.image_url}`}
                                                alt={item.product_title}
                                                style={{ width: '50px', height: '50px' }}
                                            />
                                        ) : (
                                            'No Image'
                                        )}
                                    </td>
                                    <td>{item.category_id}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="9" className="text-center">
                                    No order items available.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
        </Layout>
    );
};

export default OrderItemsForSupplier;
